import { render, staticRenderFns } from "./InternshipSponsorsList.vue?vue&type=template&id=568282b2&"
import script from "./InternshipSponsorsList.vue?vue&type=script&lang=js&"
export * from "./InternshipSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports